import { MakeVaperPart } from "./MakeYourOwnVaperTypes"

export type MakeVaperScreenContent
    = MakeVaperLetteredText
    | MakeVaperOptionText
    | MakeVaperTimedFunction
    | MakeVaperCenterText
    | MakeVaperComparePart

export enum MakeVaperContentKind {
    LETTERED_TEXT = "lettered-text",
    FUNCTION = "function",
    OPTION = "opt",
    CENTER_TEXT = "center-text",
    COMPARE = "compare"
}

interface MakeVaperComparePart {
    kind: MakeVaperContentKind.COMPARE,
    part: MakeVaperPart,
    response: boolean
}

interface MakeVaperCenterText {
    kind: MakeVaperContentKind.CENTER_TEXT
    text: string
    title?: string
}

interface MakeVaperLetteredText {
    kind: MakeVaperContentKind.LETTERED_TEXT
    delay: number
    text: string
}

interface MakeVaperTimedFunction {
    kind: MakeVaperContentKind.FUNCTION
    delay: number
    function: () => void
}

interface MakeVaperOptionText {
    kind: MakeVaperContentKind.OPTION
    part?: MakeVaperPart
    audio: string
    text: string
    yesSprite: () => Phaser.Sprite
    noSprite: () => Phaser.Sprite
}
